import { inject, Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';

import { map, withLatestFrom } from 'rxjs';

import { LoggerService } from '../../misc/services/logger.service';
import * as fromDeviceActions from '../actions/device.actions';
import * as fromLoggerActions from '../actions/logger.actions';
import * as fromPersistedStateActions from '../actions/persisted-state.actions';
import * as fromUserActions from '../actions/user.actions';
import * as fromDeviceSelectors from '../selectors/device.selectors';
import * as fromUserSelectors from '../selectors/user.selectors';

@Injectable()
export class LoggerEffects {
  private actions$ = inject(Actions);
  private store = inject(Store);
  private loggerService = inject(LoggerService);

  updateConfiguration$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromLoggerActions.updateConfiguration),
        map(({ payload }) => this.loggerService.updateConfiguration(payload))
      ),
    {
      dispatch: false
    }
  );

  loadAppInfo$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromDeviceActions.loadAppInfoSuccess, fromDeviceActions.loadAppInfoFailure),
        withLatestFrom(this.store.pipe(select(fromDeviceSelectors.selectAppVersion))),
        map((data) =>
          this.loggerService.updateConfiguration({
            version: data[1]
          })
        )
      ),
    {
      dispatch: false
    }
  );

  loadUserInfo$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(
          fromUserActions.loadMobileUserSuccess,
          fromPersistedStateActions.loadPersistedStateSuccess,
          fromPersistedStateActions.migratePersistedOldStateUserDataSuccess
        ),
        withLatestFrom(this.store.pipe(select(fromUserSelectors.selectId))),
        map((data) =>
          this.loggerService.updateConfiguration({
            id: data[1]
          })
        )
      ),
    {
      dispatch: false
    }
  );
}
